const ACTIVE_PASSIVE_OPTIONS = [
  { key: "active", value: "Active" },
  { key: "passive", value: "Passive" },
];

export const relationContactFormFields = (enableStatus, statusList) => [
  {
    type: "relation",
    name: "relation",
    label: "Relation",
    validation: (value) => (Number.isInteger(value) ? null : "Relation is required"),
  },
  {
    type: "text",
    name: "firstName",
    label: "First Name",
    validation: (value) => (!value ? "First name is required" : null),
  },
  {
    type: "text",
    name: "infix",
    label: "Infix",
  },
  {
    type: "text",
    name: "lastName",
    label: "Last Name",
    validation: (value) => (!value ? "Last name is required" : null),
  },
  {
    type: "email",
    name: "email",
    label: "Email Address",
    readOnly: true,
    validation: (value) => (!value ? "Email is required" : null),
  },
  {
    type: "phone",
    name: "phone",
    label: "Phone Number",
  },
  enableStatus 
  ? {
    type: "select",
    name: "status",
    label: "Status",
    options: Object.entries(statusList).map(([key, value]) => ({ key, value: (value as { name }).name })),
  } 
  : {
      type: "select",
      name: "isPassiveSelect",
      label: "Status",
      initialValue: "active",
      options: ACTIVE_PASSIVE_OPTIONS,
  },
];